import React from "react";
import TopBar from "./TopBar";
import Header from "./Header";
import Footer from "./Footer";
import CallButton from "./CallButton";

const Layout = ({ children }) => {
  return (
    <div className="min-h-screen flex flex-col bg-white">
      <TopBar />
      <Header />
      <main className="flex-1">{children}</main>
      <Footer />
      <CallButton />
    </div>
  );
};

export default Layout;
